import { useState, useEffect } from "react";
import { API_BASE_URL } from "@/api/base";
import PocketBase from "pocketbase";
import { useQuery } from "@tanstack/react-query";
import { getUserInfo, callWithAuth, getUserInfoNoRedirect } from "@/api/Api";
import { GetUserInfoResponse } from "@shared_types";
export function useAuthProviders() {
  const [authProviders, setAuthProviders] = useState<any[]>([]);

  useEffect(() => {
    const isios = /ipad|iphone|ipod/.test(navigator.userAgent);

    const pb = new PocketBase(API_BASE_URL);
    const loadlinks = async () => {
      try {
        const authmethods = await pb.collection("users").listAuthMethods();
        if (!isios) {
          authmethods.authProviders.sort((a: any, b: any) =>
            b.name.localeCompare(a.name)
          );
        }
        setAuthProviders(authmethods.authProviders);
      } catch (error) {
        console.error("failed to load oauth2 providers:", error);
      }
    };
    loadlinks();
  }, []);
  return authProviders;
}

export function useUser(): {
  user: GetUserInfoResponse | undefined;
  isLoading: boolean;
  isError: boolean;
} {
  const userInfoQuery = useQuery({
    queryKey: ["userInfo"],
    queryFn: () => {
      return callWithAuth(getUserInfo);
    },
  });
  return {
    user: userInfoQuery.data,
    isLoading: userInfoQuery.isLoading,
    isError: userInfoQuery.isError,
  };
}

// On a bad auth request aka user lot logged in this hook wont redirect to login page
export function useUserNoRedirect() {
  const userInfoQuery = useQuery({
    queryKey: ["userInfoNoRedirect"],
    queryFn: () => {
      return callWithAuth(getUserInfoNoRedirect);
    },
  });
  return {
    user: userInfoQuery.data,
    isLoading: userInfoQuery.isLoading,
    isError: userInfoQuery.isError,
  };
}
